import { render, staticRenderFns } from "./reliableRegister.vue?vue&type=template&id=6e86fcb4&scoped=true"
import script from "./reliableRegister.vue?vue&type=script&lang=js"
export * from "./reliableRegister.vue?vue&type=script&lang=js"
import style0 from "./reliableRegister.vue?vue&type=style&index=0&id=6e86fcb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e86fcb4",
  null
  
)

export default component.exports